import React, { useState, useEffect, useRef } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import MenuIcon from "@mui/icons-material/Menu";
import PublicIcon from "@mui/icons-material/Public";
import Avatar from "@mui/material/Avatar";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";
import FormatDateTimestamp from "../../../helperFunctions/FormatDateTimestamp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import {
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import {
  CircularProgress,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import axios from "axios";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Styles from "../../../styles/vendorDashboard.module.css";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import styles from "../../../styles/adminPortal.module.css";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter.jsx";
import Decrypt from "../../../shared/utils/Decrypt.js";
import GlobalSnackbar from "../../../shared/utils/GlobalSnackbar.jsx";
import ContractorAddEdit from "./Contractor.addEdit.jsx";
import User_plus from "../../../shared/assets/icons/User_plus.jsx";
import ContractorView from "./Contractor.view.jsx";
import DeletedUsersRestore from "../../../shared/createForms/DeletedUsersRestore.jsx";

function EnhancedTableHead(props) {
  let role = localStorage.getItem("role");

  // Check if any search filters are active
  const hasActiveFilters = Object.values(props.searchInputs || {}).some(
    (value) => value && value.toString().trim() !== "",
  );

  return (
    <TableHead className={styles.tableHead}>
      <TableRow>
        {props.headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            className={styles.tableCell}
            sx={{
              minWidth: headCell.width,
            }}
          >
            <span className={styles.headCellHeading}>{headCell.label} </span>
            <div className={styles.topBorderDiv}>
              {[
                "state",
                "city",
                ...(role == "-1" ? ["phoneNumber"] : []),
                "name",
                "addedBy",
                "phoneNumber",
                "source",
              ].includes(headCell.id) && (
                <input
                  type="text"
                  className={styles.searchInput}
                  placeholder={`Search`}
                  onChange={(e) => props.handleSearchChangeHead(e, headCell.id)}
                  value={props.searchInputs?.[headCell.id] || ""}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>

      {/* Only show count when there are active filters AND filteredIPCount > 0 */}
      {props.filteredIPCount > 0 && hasActiveFilters && (
        <TableRow>
          <TableCell
            colSpan={props.headCells.length}
            sx={{
              backgroundColor: "#DEEBFF",
              position: "relative",
              paddingBottom: "2rem",
            }}
          >
            <div className="fixed left-1/2 transform -translate-x-1/2 text-sm font-medium">
              {`${props.filteredIPCount} Installation Partners`}
            </div>
          </TableCell>
        </TableRow>
      )}
    </TableHead>
  );
}

function EnhancedTableToolbar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [clearDateFilter, setClearDateFilter] = useState(false);
  const [rotate, setRotate] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dateFilterAnchorEl, setDateFilterAnchorEl] = useState(null);

  const handleDateClick = (event) => {
    setDateFilterAnchorEl(event.currentTarget);
  };
  const handleDateChange = (e) => {
    if (e?.dateFilter) {
      props.setSearchInputs((prev) => ({
        ...prev,
        fromDate: e.dateFilter.fromDate,
        toDate: e.dateFilter.toDate,
      }));
    }
    setDateFilterAnchorEl(null);
    setMobileMenuOpen(false);
  };

  const handleDateClose = () => {
    setDateFilterAnchorEl(null);
  };
  const handleTrashOpen = async (e) => {
    props.getAllDeletedContractors();
    props.OnTrashModalOpen(true);
  };

  const { numSelected } = props;
  const handleOpen = (e) => {
    props.OnModalOpen(true);
    props.setSelectedContractor({});
    setMobileMenuOpen(false);
  };

  const handleMapOpen = () => {
    props.setIsMapState(true);
    setMobileMenuOpen(false);
  };
  const handleTableOpen = () => {
    props.setIsMapState(false);
    setMobileMenuOpen(false);
  };
  const handleModal = () => {
    props.setCreateModal(true);
    setMobileMenuOpen(false);
  };

  const handelViewSlot = () => {
    props.setSlotModalView(true);
    setMobileMenuOpen(false);
  };

  const handleClickRefresh = () => {
    setClearDateFilter(true);
    // Clean all filters
    props.setSearchInputs({
      state: "",
      city: "",
      phoneNumber: "",
      name: "",
      iticourse: "",
      addedBy: "",
      updatedBy: "",
      fromDate: "",
      toDate: "",
      source: "",
    });

    setRotate(true);
    props.contractorData();
    props.setPageSize(10);
    setTimeout(() => setRotate(false), 500);
    setMobileMenuOpen(false);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Handle mobile menu open/close
  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className="border-b flex justify-between items-center h-14 pt-2">
      {!isMobile && (
        <>
          <div className="font-bold text-md text-gray-600">
            Total Contractor : {props.totalContractor}
          </div>
          <div>
            <Tooltip title="Add Contractor">
              <IconButton onClick={handleOpen}>
                <User_plus sx={{ color: "#666666" }} />
              </IconButton>
            </Tooltip>
            {localStorage.getItem("role") == "-1" && (
              <Tooltip title="Trash">
                <IconButton onClick={handleTrashOpen}>
                  <DeleteOutlinedIcon sx={{ color: "#666666" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </>
      )}

      {isMobile && (
        <div className="flex justify-between items-center w-full">
          <Typography
            sx={{ flex: "1 1 100%" }}
            variant="p"
            id="tableTitle"
            component="div"
          >
            Total Contractor : {props.totalContractor}
          </Typography>
          <div>
            <IconButton color="inherit" onClick={handleMobileMenuOpen}>
              <MenuIcon />
            </IconButton>
          </div>
          {localStorage.getItem("role") == "-1" && (
            <Tooltip title="Trash">
              <IconButton onClick={handleTrashOpen}>
                <DeleteOutlinedIcon sx={{ color: "#666666" }} />
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
}
var oldData = [];
export default function Contractor() {
  // Declare states
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [isSupervisorData, setIsSupervisorData] = useState([]);

  const handleImageClickPhoto = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsImage(true);
  };
  const email = localStorage.getItem("superAdminEmail"); // Replace with the actual email to which the OTP should be sent
  const firstInputRef = useRef(null);
  const [pageSize, setPageSize] = useState(10);
  const pageSizeOptions = [1, 5, 10, 50, 100, 200];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const serverURL = process.env.REACT_APP_URL;
  const [isEditModalOpen, setEditModalOpen] = useState(false);

  const [filteredIPCount, setFilteredIPCount] = useState(0);
  const [selectorContractor, setSelectedContractor] = useState(false);
  const [contractorData, setContractorData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedIPs, setSelectedIPs] = useState([]);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [allDeletedContractors, setAllDeletedContractors] = useState([]);
  const [isTrashLoading, setTrashLoading] = useState(false);

  const debounceRef = useRef(null);
  const [ipModalOpen, setIpModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null); // Store the selected row ID
  const [isContractorView, setIsContractorView] = useState(false);
  const [isTotalContractors, setTotalContractors] = useState(null);
  const [filterLoading, setFilterLoading] = useState(false);
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    phoneNumber: "",
    name: "",
    addedBy: "",
    updatedBy: "",
    fromDate: "",
    toDate: "",
    source: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [headCells, setHeadCells] = useState([]);

  useEffect(() => {
    const role = parseInt(localStorage.getItem("role"));

    const baseHeadCells = [
      { id: "name", label: "Name", width: 200 },
      { id: "phoneNumber", label: "Phone Number", width: 160 },
      { id: "installationPartner", label: "Onboarded Ips", width: 160 },

      { id: "state", label: "State", width: 160 },
      { id: "city", label: "City", width: 140 },
      { id: "createdAt", label: "Added On", width: 160 },

      ...(role !== 1 ? [{ id: "action", label: "Action", width: 80 }] : []),
    ];

    setHeadCells(baseHeadCells);
  }, []);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const getAllContractors = async (page, pageSize, query = "") => {
    try {
      const token = localStorage.getItem("token");
      setFilterLoading(true);

      const url = `${serverURL}/installationPartnerSupervisor/viewAll?page=${page}&limit=${pageSize}${
        query ? `&${query}` : ""
      }`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response?.data?.success) {
        setTotalPages(response?.data.pagination?.totalPages);
        setTotalContractors(response?.data.pagination?.total);

        const getData = response.data.data.map((ele) => ({
          ...ele,
          phoneNumber: Decrypt(ele.phoneNumber),
        }));

        setContractorData(getData);
      }
    } catch (error) {
      console.error("Error fetching contractorData:", error);
    } finally {
      setFilterLoading(false);
    }
  };

  const getALLDeletedContractors = async () => {
    try {
      setTrashLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/installationPartnerSupervisor/allDeletedContractors`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setAllDeletedContractors(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  const handleViewClick = (e, v) => {
    setIsContractorView(true);
    setSelectedContractor(v);
    setAnchorEl(null);
  };

  const handleDelete = (e, v) => {
    e.preventDefault();
    setAnchorEl(null);

    Swal.fire({
      icon: "error",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axios
            .put(
              `${serverURL}/installationPartnerSupervisor/delete/${v?._id}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              },
            )
            .then((response) => {
              setSnackbar({
                open: true,
                message: response.data.message,
                severity: "success",
              });
              getAllContractors();
            })
            .catch((error) => {
              console.error("Error deleting Contractor:", error);
              Swal.fire("There was an error deleting the Contractor.");
            });
        } catch (error) {
          console.error(error);
          Swal.fire("There was an error deleting the Contractor.");
        }
      } else if (result.isDenied) {
        Swal.fire("Changes are not deleted", "", "info");
      }
    });
  };

  const handleEditClick = (e, v) => {
    setEditModalOpen(true);
    setSelectedContractor(v);
    setAnchorEl(null);
  };

  const handleSearchChangeHead = (e, key) => {
    let value = e.target.value;

    // ✅ Phone number validation (only digits)
    if (key === "phoneNumber") {
      // Remove non-digit characters
      value = value.replace(/\D/g, "");

      // Optional: limit length (e.g., 10 digits)
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
    } else {
      value = value.toLowerCase();
    }

    const updatedInputs = {
      ...searchInputs,
      [key]: value,
    };

    setSearchInputs(updatedInputs);

    const allFieldsEmpty = Object.values(updatedInputs).every(
      (val) => val.trim() === "",
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (allFieldsEmpty) {
        getAllContractors(1, pageSize);
        return;
      }

      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      getAllContractors(1, pageSize, queryParams.toString());
    }, 500);
  };
  useEffect(() => {
    getAllContractors(page, pageSize);
  }, []);

  const buildQueryParams = (inputs) => {
    let queryParams = new URLSearchParams();

    Object.entries(inputs).forEach(([key, value]) => {
      if (value.trim() !== "") {
        queryParams.append(key, value);
      }
    });

    return queryParams.toString();
  };

  const handlePageChange = async (e, value) => {
    setPage(value);

    const query = buildQueryParams(searchInputs);

    await getAllContractors(value, pageSize, query);
  };
  const handlePageSizeChange = async (e) => {
    const newSize = parseInt(e.target.value, 10);

    setPageSize(newSize);
    setPage(1);

    const query = buildQueryParams(searchInputs);

    await getAllContractors(1, newSize, query);
  };

  const handleIconOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowId(rowId); // Set the selected row ID
  };
  const handleIconClose = () => {
    setAnchorEl(null);
    setSelectedRowId(null); // Reset the selected row ID
  };

  return (
    <div className={styles.tableGround}>
      <Box>
        <Paper
          sx={{ width: "100%", boxShadow: "none" }}
          className={styles.tableGap}
        >
          <EnhancedTableToolbar
            contractorData={getAllContractors}
            setPageSize={setPageSize}
            onSearchChange={(value) => handleSearchChangeHead(value)}
            totalContractor={isTotalContractors}
            setSelectedContractor={setSelectedContractor}
            setSearchInputs={setSearchInputs}
            OnModalOpen={setEditModalOpen}
            getAllDeletedContractors={getALLDeletedContractors}
            OnTrashModalOpen={setIsTrashModalOpen}
          />

          <>
            <TableContainer
              className={`${styles.tableContainer} ${Styles["custom-scrollbar"]}`}
            >
              <Table
                stickyHeader
                // sx={{ minWidth: 750 }}
                className="rounded-lg "
              >
                <EnhancedTableHead
                  rowCount={contractorData?.length}
                  headCells={headCells}
                  //   userListData={getcontractorDataList}
                  setSearchInputs={setSearchInputs} // Function to update search inputs
                  handleSearchChangeHead={handleSearchChangeHead}
                  searchInputs={searchInputs}
                  filteredIPCount={filteredIPCount}
                />
                {filterLoading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={headCells.length}
                        align="center"
                        style={{ borderBottom: "none" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "20px",
                          }}
                        >
                          <CircularProgress />
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    {contractorData && contractorData?.length > 0 ? (
                      <TableBody>
                        {contractorData?.map((v, index) => {
                          const role = localStorage.getItem("role");
                          return (
                            <TableRow
                              hover
                              className={styles.tableRowHead}
                              tabIndex={-1}
                              key={v._id}
                              onClick={(e) => {
                                handleViewClick(e, v); // Perform the intended action
                              }}
                            >
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  return (
                                    <Tooltip
                                      title={CapitalizeFirstLetter(v?.name)}
                                      arrow
                                      placement="top"
                                    >
                                      <span className="flex flex-row items-center gap-2">
                                        <Avatar
                                          className="custom-avatar"
                                          variant="rounded"
                                          src={v?.profilePic || undefined} // 👈 photo aaye to show
                                          style={{
                                            background: v?.profilePic
                                              ? "transparent"
                                              : "var(--light-primary-color)",
                                            color: "var(--primary-color)",
                                          }}
                                        >
                                          {/* 👇 if pic is not available then First letter of name is shown */}
                                          {!v?.profilePic &&
                                            CapitalizeFirstLetter(
                                              v?.name?.charAt(0),
                                            )}
                                        </Avatar>

                                        <span className="truncate max-w-[180px]">
                                          {CapitalizeFirstLetter(v?.name)}
                                        </span>
                                      </span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>

                              <TableCell className={styles.tableRow}>
                                <span>{v?.phoneNumber}</span>
                              </TableCell>
                              <TableCell
                                className={styles.tableRow}
                                onClick={(e) => e.stopPropagation()}
                              >
                                {v?.installationPartners?.length > 0 ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <span style={{ color: "#418cff" }}>
                                      {v.installationPartners.length} Partners
                                    </span>

                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setSelectedIPs(v.installationPartners);
                                        setOpenModal(true);
                                      }}
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </div>
                                ) : (
                                  <span style={{ color: "#999" }}>
                                    No IP onboarded
                                  </span>
                                )}
                              </TableCell>

                              {/* <TableCell className={styles.tableRow}>
                            <span>
                              {`${v?.address}, ${v?.city}, ${v?.state}, ${v?.zipCode}` ||
                                "N/A"}
                            </span>
                          </TableCell> */}
                              <TableCell className={styles.tableRow}>
                                <span>{v?.state || "N/A"}</span>
                              </TableCell>
                              <TableCell className={styles.tableRow}>
                                {(() => {
                                  const city = v.city || "N/A";

                                  // Truncate if longer than 17 characters
                                  const displayCity =
                                    city.length > 25
                                      ? city.substring(0, 25) + "..."
                                      : city;

                                  return (
                                    <Tooltip
                                      title={city} // Show full city name on hover
                                      arrow
                                      placement="top"
                                      disableHoverListener={city.length <= 25} // Show tooltip only if truncated
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",
                                          maxWidth: "100%",
                                        }}
                                      >
                                        {displayCity}
                                      </span>
                                    </Tooltip>
                                  );
                                })()}
                              </TableCell>

                              <TableCell className={styles.tableRow}>
                                {" "}
                                <FormatDateTimestamp timestamp={v.createdAt} />
                              </TableCell>
                              {role != 1 && (
                                <TableCell
                                  className={styles.tableRow}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="flex justify-center">
                                    <Tooltip title="Click">
                                      <IconButton
                                        onClick={(e) =>
                                          handleIconOpen(e, v._id)
                                        }
                                      >
                                        <MoreVertIcon
                                          style={{
                                            color: "var(--primary-color)",
                                          }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                  <Menu
                                    anchorEl={anchorEl}
                                    open={
                                      Boolean(anchorEl) &&
                                      selectedRowId === v._id
                                    }
                                    onClose={handleIconClose}
                                    keepMounted
                                  >
                                    {/* Details Section */}

                                    <MenuItem
                                      onClick={(e) => {
                                        handleEditClick(e, v, "edit");
                                        // handleIconClose(); // Close the menu
                                        // setIdForView(null);
                                      }}
                                      //   disabled={isActionLoading}
                                    >
                                      <EditOutlinedIcon
                                        style={{ color: "#6b7280" }}
                                      />{" "}
                                      <p className="ml-2 font-semibold text-[#6b7280]">
                                        Edit
                                      </p>
                                    </MenuItem>

                                    {localStorage.getItem("role") == "-1" && (
                                      <MenuItem
                                        onClick={(e) => handleDelete(e, v)}
                                      >
                                        <DeleteOutlinedIcon
                                          style={{ color: "red" }}
                                        />{" "}
                                        <p className="ml-2 font-semibold text-[red]">
                                          Delete
                                        </p>
                                      </MenuItem>
                                    )}
                                  </Menu>
                                </TableCell>
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={headCells?.length}
                          sx={{ borderBottom: "none" }}
                        >
                          <div className="flex justify-center items-center h-64">
                            No Contractor Found
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
              </Table>
            </TableContainer>
            <hr
              className="mt-2 bg-gray-200 "
              style={{ border: "0.5px solid var(--light-grey-color)" }}
            />

            <div className="flex items-center justify-between ">
              <FormControl
                variant="standard"
                size="small"
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 1,
                  "& .MuiInputBase-root:before": { borderBottom: "none" },
                  "& .MuiInputBase-root:after": { borderBottom: "none" },
                  "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                }}
              >
                <InputLabel
                  id="page-size-label"
                  sx={{
                    position: "static",
                    transform: "none",
                    fontSize: "14px",
                    marginRight: "8px",
                    marginTop: "2px",
                  }}
                >
                  Rows
                </InputLabel>
                <Select
                  labelId="page-size-label"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  label="Rows"
                >
                  {pageSizeOptions.map((size) => (
                    <MenuItem key={size} value={size}>
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <GlobalSnackbar
                snackbar={snackbar}
                handleClose={handleSnackbarClose}
              />

              <Pagination
                className="p-2 flex justify-center"
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#418cff", // Blue background for selected
                    color: "#fff", // White text for selected
                  },
                  "& .MuiPaginationItem-root.Mui-selected:hover": {
                    backgroundColor: "#3366cc", // Darker blue on hover
                  },
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#ddd", // Light gray for hovered items
                    },
                  },
                }}
              />
            </div>
          </>
        </Paper>
      </Box>
      {
        <ContractorAddEdit
          setSnackbar={setSnackbar}
          getAllContractors={getAllContractors}
          isModalOpen={isEditModalOpen}
          setIsModalOpen={setEditModalOpen}
          selectedContractorData={selectorContractor}
          setSelectedContractor={setSelectedContractor}
        />
      }
      {isContractorView && (
        <ContractorView
          isInstallationPartnerModalOpen={isContractorView}
          setIsContractorView={setIsContractorView}
          setAnchorEl={setAnchorEl}
          setSnackbar={setSnackbar}
          selectorContractor={selectorContractor}
          setSelectedContractor={setSelectedContractor}
        />
      )}
      {isTrashModalOpen && (
        <DeletedUsersRestore
          list={allDeletedContractors}
          type="CONTRACTOR"
          openModal={isTrashModalOpen}
          loading={isTrashLoading}
          getAllDeletedUsers={getALLDeletedContractors}
          setIsTrashModalOpen={setIsTrashModalOpen}
          setTrashLoading={setTrashLoading}
          getAllList={getAllContractors}
        />
      )}
      {
        <Dialog
          open={openModal}
          onClose={() => setOpenModal(false)}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: "14px",
              padding: "8px 0",
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "#111827",
              borderBottom: "1px solid #eee",
              padding: "16px 20px",
            }}
          >
            Installation Partners
            <IconButton
              onClick={() => setOpenModal(false)}
              sx={{
                position: "absolute",
                right: 10,
                top: 10,
                backgroundColor: "#f3f4f6",
                "&:hover": {
                  backgroundColor: "#e5e7eb",
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ padding: "16px 20px" }}>
            {selectedIPs.length > 0 ? (
              selectedIPs.map((ip, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px",
                    marginBottom: "10px",
                    borderRadius: "10px",
                    backgroundColor: "#f9fafb",
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#eef4ff")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f9fafb")
                  }
                >
                  {/* Left Section */}
                  <div>
                    <div
                      style={{
                        fontWeight: 600,
                        color: "#111827",
                        fontSize: "14px",
                      }}
                    >
                      {i + 1}. {ip.name}
                    </div>

                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                        marginTop: "2px",
                      }}
                    >
                      {Decrypt(ip.phoneNumber) || "N/A"}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "30px",
                  color: "#9ca3af",
                  fontSize: "14px",
                }}
              >
                No Installation Partners Found
              </div>
            )}
          </DialogContent>
        </Dialog>
      }
    </div>
  );
}
